import { Action } from 'redux';
import { OperatorFunction } from 'rxjs';
import { filter } from 'rxjs';

/**
 * Legacy action-typed / redux-observable v1–v2 style `ofType`.
 *
 * redux-observable v3 changed `ofType` to require 2–3 type arguments where the
 * second is a string literal type name. Our codebase still uses:
 *   ofType<Actions>('Foo.Bar')
 *   ofType<Actions, TypeMap['Foo.Bar']>('Foo.Bar')
 */
export function ofType<Input extends Action = Action, Output extends Input = Input>(
    ...types: string[]
): OperatorFunction<Input, Output> {
    return filter((action): action is Output => types.indexOf((action as Action).type) > -1);
}
